export default "__VITE_ASSET__DFrZANRo__"